import React, { useEffect, useRef, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { Box } from "@mui/material";
import { useTranslation } from "react-i18next";
// import { handleReorderTaskList } from "../../../appStore/actions/ArkchatGroup/action";
import TaskList from "../../../../common/TaskList/TaskList";
import NoTaskListComponent from "../NoTaskListComponent";
import LoadingSpinner from "../../../../common/LoadingSpinner/LoadingSpinner";
import { handleReorderTaskList } from "../../../../appStore/actions/ArkchatGroup/action";

const TaskListPage = ({
  handleClickTaskUpdate,
  taskTabValue,
  handleViewThreadClick,
  handleApplyTaskFilter,
  filterChecked,
}) => {
  
  const { t } = useTranslation();
  const appContent = t("AppContent", { returnObjects: true });
  const storeTasklist = useSelector((state) => state?.arkchatgroup?.taskList);
  const isLoading = useSelector((state) => state?.localAppReducer?.isLoading);
  const dispatch = useDispatch();
  
  
  const [isScrollingToBottom, setIsScrollingToBottom] = useState(false);
  const [startTaskOpen, setStartTaskOpen] = useState(null);
  const [draggedIndex, setDraggedIndex] = useState(null);
  const [dragOverIndex, setDragOverIndex] = useState(null);

  const taskContainerRef = useRef(null);
  
  let content = appContent?.KEY229;
  if (filterChecked?.length) {
    content = appContent?.KEY231;
  } else if (taskTabValue === 4) {
    content = appContent?.KEY233;
  }
  
  const handleStartTask = (item) => {
    if (startTaskOpen?.timetoken === item?.timetoken) {
      setStartTaskOpen(null);
    } else {
      setStartTaskOpen(item);
    }
  };

  // Drag and Drop handlers
  const handleDragStart = (e, index, taskItem) => {
    setDraggedIndex(index);
  };

  const handleDragOver = (e, index) => {
    e.preventDefault();
    setDragOverIndex(index);
  };

  const handleDrop = (e, draggedIndex, dropIndex) => {
    e.preventDefault();
    
    if (draggedIndex === dropIndex) {
      setDraggedIndex(null);
      setDragOverIndex(null);
      return;
    }

    // Create new array with reordered tasks
    const newTaskList = [...storeTasklist];
    const draggedTask = newTaskList[draggedIndex];
    
    // Remove the dragged task from its original position
    newTaskList.splice(draggedIndex, 1);
    
    // Insert the dragged task at the new position
    newTaskList.splice(dropIndex, 0, draggedTask);

    // Log the new arrangement
    // console.log("Task reordered:");
    // console.log("Dragged from index:", draggedIndex, "to index:", dropIndex);
    // console.log("Dragged task:", draggedTask?.id);
    // console.log("New task arrangement:", newTaskList.map((task, idx) => ({
    //   index: idx,
    //   id: task?.id,
    //   title: task?.title || task?.task_title || "No title"
    // })));

    // Dispatch the reorder action
    dispatch(handleReorderTaskList(newTaskList));

    // Reset drag state
    setDraggedIndex(null);
    setDragOverIndex(null);
  };

  const handleDragEnd = (e, index) => {
    // Reset drag state when drag ends
    setDraggedIndex(null);
    setDragOverIndex(null);
  };
  
  const handleScroll = () => {
    const { scrollTop, scrollHeight, clientHeight } = taskContainerRef.current;
    const isAtBottom = scrollTop + clientHeight >= scrollHeight - 50;
    setIsScrollingToBottom(isAtBottom);
  };
  
  useEffect(() => {
    if (isScrollingToBottom) {
      const page = Math.floor(storeTasklist?.length / 4) + 1;
      handleApplyTaskFilter(
        filterChecked,
        page,
        storeTasklist[storeTasklist?.length - 1]
      );
    }
  }, [isScrollingToBottom]);

  if (storeTasklist?.length > 0) {
    return (
      <Box
        ref={taskContainerRef}
        onScroll={handleScroll}
        overflow={"clip"}
        height={"100%"}
        sx={{
          '&::-webkit-scrollbar': {
            width: '8px',
          },
          '&::-webkit-scrollbar-track': {
            background: '#f1f1f1',
          },
          '&::-webkit-scrollbar-thumb': {
            background: '#c1c1c1',
            borderRadius: '4px',
          },
          '&::-webkit-scrollbar-thumb:hover': {
            background: '#a8a8a8',
          },
        }}
      >
        {isLoading && <LoadingSpinner />}
        {!isLoading &&
          storeTasklist?.map((item, indx) => {
            return (
              <TaskList
                handleViewThreadClick={handleViewThreadClick}
                handleClickTaskUpdate={handleClickTaskUpdate}
                taskTabValue={taskTabValue}
                taskItem={item}
                startTaskOpen={startTaskOpen}
                setStartTaskOpen={setStartTaskOpen}
                handleStartTask={handleStartTask}
                indx={indx}
                key={item?.id || indx + "tasklistcomp"}
                tabValue={1}
                onDragStart={handleDragStart}
                onDragOver={handleDragOver}
                onDrop={handleDrop}
                onDragEnd={handleDragEnd}
                isDragging={draggedIndex === indx}
                isDragOver={dragOverIndex === indx && draggedIndex !== indx}
              />
            );
          })}
      </Box>
    );
  } else {
    return (
      <>
        {isLoading ? (
          <LoadingSpinner />
        ) : (
          <NoTaskListComponent content={content} />
        )}
      </>
    );
  }
};

export default TaskListPage;
